package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.Grid4x4W500Rounded: ImageVector
    get() {
        if (_grid4x4W500Rounded != null) {
            return _grid4x4W500Rounded!!
        }
        _grid4x4W500Rounded = Builder(name = "Grid4x4W500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(187.09f, 772.91f)
                horizontalLineToRelative(-74.5f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.33f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.32f)
                quadToRelative(13.17f, -13.18f, 32.33f, -13.18f)
                horizontalLineToRelative(74.5f)
                lineTo(187.09f, 525.5f)
                horizontalLineToRelative(-74.5f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadTo(67.09f, 499.15f, 67.09f, 480.0f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(74.5f)
                verticalLineToRelative(-156.41f)
                horizontalLineToRelative(-74.5f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.18f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                quadToRelative(0.0f, -19.16f, 13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(74.5f)
                verticalLineToRelative(-74.5f)
                quadToRelative(0.0f, -19.16f, 13.17f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.33f, -13.17f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.17f, 13.18f, 32.33f)
                verticalLineToRelative(74.5f)
                lineTo(434.5f, 187.09f)
                verticalLineToRelative(-74.5f)
                quadToRelative(0.0f, -19.16f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.33f)
                verticalLineToRelative(74.5f)
                horizontalLineToRelative(156.41f)
                verticalLineToRelative(-74.5f)
                quadToRelative(0.0f, -19.16f, 13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.33f)
                verticalLineToRelative(74.5f)
                horizontalLineToRelative(74.5f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.33f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.32f)
                quadToRelative(-13.17f, 13.18f, -32.33f, 13.18f)
                horizontalLineToRelative(-74.5f)
                verticalLineToRelative(156.41f)
                horizontalLineToRelative(74.5f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.33f, 13.17f)
                horizontalLineToRelative(-74.5f)
                verticalLineToRelative(156.41f)
                horizontalLineToRelative(74.5f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.18f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.32f)
                quadToRelative(0.0f, 19.16f, -13.17f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.33f, 13.17f)
                horizontalLineToRelative(-74.5f)
                verticalLineToRelative(74.5f)
                quadToRelative(0.0f, 19.16f, -13.17f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.33f, 13.17f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.17f, -13.18f, -32.33f)
                verticalLineToRelative(-74.5f)
                lineTo(525.5f, 772.91f)
                verticalLineToRelative(74.5f)
                quadToRelative(0.0f, 19.16f, -13.17f, 32.33f)
                quadTo(499.15f, 892.91f, 480.0f, 892.91f)
                reflectiveQuadToRelative(-32.33f, -13.17f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.33f)
                verticalLineToRelative(-74.5f)
                lineTo(278.09f, 772.91f)
                verticalLineToRelative(74.5f)
                quadToRelative(0.0f, 19.16f, -13.18f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.32f, 13.17f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.33f)
                verticalLineToRelative(-74.5f)
                close()
                moveTo(278.09f, 681.91f)
                lineTo(434.5f, 681.91f)
                lineTo(434.5f, 525.5f)
                lineTo(278.09f, 525.5f)
                verticalLineToRelative(156.41f)
                close()
                moveTo(525.5f, 681.91f)
                horizontalLineToRelative(156.41f)
                lineTo(681.91f, 525.5f)
                lineTo(525.5f, 525.5f)
                verticalLineToRelative(156.41f)
                close()
                moveTo(278.09f, 434.5f)
                lineTo(434.5f, 434.5f)
                verticalLineToRelative(-156.41f)
                lineTo(278.09f, 278.09f)
                verticalLineToRelative(156.41f)
                close()
                moveTo(525.5f, 434.5f)
                horizontalLineToRelative(156.41f)
                verticalLineToRelative(-156.41f)
                lineTo(525.5f, 278.09f)
                verticalLineToRelative(156.41f)
                close()
            }
        }
        .build()
        return _grid4x4W500Rounded!!
    }

private var _grid4x4W500Rounded: ImageVector? = null
